/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

export const updateMarks = (oldMarks, mark) => {
  let marks = _.uniq(_.concat(oldMarks, [mark]));
  marks = _.take(marks, (_.indexOf(marks, mark) + 1));

  return marks;
};

class PageParams {
  constructor() {
    this.data = {};
  }

  setMarks(m, key) {
    this.data[key] = m;
  }

  getMarks(key) {
    return this.data[key];
  }

  setFilter(t, key) {
    this.data[key] = t;
  }

  getFilter(key) {
    return this.data[key];
  }
}

export const pageParams = new PageParams();




// WEBPACK FOOTER //
// ./src/utils/pagerUtil.js